module.exports = __webpack_public_path__ + "img/icon_form_white.86efcda9.svg";